import { useState } from "react";
import styled from "styled-components";
import { LuGift, LuCopy, LuCheck, LuSend, LuWallet } from "react-icons/lu";
import { colors, font, radius, shadow } from "../../styles/theme/tokens";

// Блоки на головній учня: нагадування про продовження (≤2 уроки) і «Приведи друга» з особистим посиланням.
const SITE = "https://speaksy.com.ua";
const MANAGER_TG = "https://t.me/lera_eng";

const lessonsWord = (n) => {
  const a = Math.abs(n) % 100, b = a % 10;
  if (b === 1 && a !== 11) return "урок";
  if (b >= 2 && b <= 4 && (a < 12 || a > 14)) return "уроки";
  return "уроків";
};

export function RenewalBanner({ data }) {
  const left = Number(data?.totalLessons ?? 0);
  if (!data || data.isPaused || left > 2) return null;
  const title = left > 0
    ? `Залишилось ${left} ${lessonsWord(left)}`
    : "Оплачені уроки закінчилися";
  return (
    <Banner $tone="amber">
      <Icon $tone="amber"><LuWallet size={22} /></Icon>
      <div style={{ flex: "1 1 240px", minWidth: 0 }}>
        <Title>{title}</Title>
        <Text>Продовж зараз, щоб не було перерви в навчанні. Більший пакет — дешевший урок: 32 уроки по 345 грн, 50 — по 325 грн.</Text>
      </div>
      <Btn as="a" href={MANAGER_TG} target="_blank" rel="noopener noreferrer">Написати менеджеру</Btn>
    </Banner>
  );
}

export function ReferralCard({ data }) {
  const [copied, setCopied] = useState(false);
  if (!data?.studentId) return null;
  const link = `${SITE}/?ref=${encodeURIComponent(data.studentId)}&utm_source=referral&utm_medium=student_link`;
  const shareText = `Я вчу англійську в Speaksy — індивідуально, з класним викладачем. Запишись на безкоштовний пробний урок за моїм посиланням, і після першої оплати кожен із нас отримає +2 уроки в подарунок:`;
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(`${shareText} ${link}`);
    } catch {
      const t = document.createElement("textarea");
      t.value = `${shareText} ${link}`; document.body.appendChild(t); t.select(); document.execCommand("copy"); t.remove();
    }
    setCopied(true);
    setTimeout(() => setCopied(false), 2500);
  };
  return (
    <Banner>
      <Icon><LuGift size={22} /></Icon>
      <div style={{ flex: "1 1 240px", minWidth: 0 }}>
        <Title>Приведи друга — +2 уроки кожному з вас</Title>
        <Text>Поділися своїм посиланням. Коли друг оплатить перший пакет, ти й друг отримаєте по 2 уроки в подарунок.</Text>
        <LinkBox title={link}>{link.replace("https://", "")}</LinkBox>
        <Row>
          <Btn onClick={copy}>{copied ? <><LuCheck size={16} /> Скопійовано</> : <><LuCopy size={16} /> Скопіювати повідомлення</>}</Btn>
          <Btn $ghost as="a" target="_blank" rel="noopener noreferrer"
            href={`https://t.me/share/url?url=${encodeURIComponent(link)}&text=${encodeURIComponent(shareText)}`}>
            <LuSend size={16} /> Telegram
          </Btn>
          <Btn $ghost as="a" href={`viber://forward?text=${encodeURIComponent(`${shareText} ${link}`)}`}>Viber</Btn>
        </Row>
      </div>
    </Banner>
  );
}

const Banner = styled.section`
  display: flex;
  gap: 14px;
  align-items: flex-start;
  flex-wrap: wrap;
  margin-top: 16px;
  padding: 16px 18px;
  border-radius: ${radius.lg};
  border: 1px solid ${(p) => (p.$tone === "amber" ? colors.amber : colors.line)};
  background: ${(p) => (p.$tone === "amber" ? colors.amberSoft : colors.surface)};
  box-shadow: ${shadow.card};
  font-family: ${font.text};
  color: ${colors.ink};
`;
const Icon = styled.div`
  width: 42px; height: 42px; flex: none;
  display: grid; place-items: center;
  border-radius: ${radius.md};
  background: ${(p) => (p.$tone === "amber" ? colors.surface : colors.brandSoft)};
  color: ${(p) => (p.$tone === "amber" ? colors.amberDeep : colors.brandDeep)};
`;
const Title = styled.h3`margin: 0 0 4px; font-size: 1.05rem; font-weight: 800;`;
const Text = styled.p`margin: 0; font-size: 0.92rem; color: ${colors.muted}; line-height: 1.45;`;
const LinkBox = styled.div`
  margin-top: 10px; padding: 8px 12px; border-radius: ${radius.sm};
  background: ${colors.bg}; font-size: 0.85rem; color: ${colors.brandDark};
  overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
`;
const Row = styled.div`display: flex; gap: 8px; flex-wrap: wrap; margin-top: 10px;`;
const Btn = styled.button`
  display: inline-flex; align-items: center; gap: 6px;
  border-radius: ${radius.sm}; padding: 9px 14px; cursor: pointer; text-decoration: none;
  font: inherit; font-weight: 800; font-size: 0.9rem; white-space: nowrap;
  background: ${(p) => (p.$ghost ? colors.surface : colors.brand)};
  color: ${(p) => (p.$ghost ? colors.ink : "#fff")};
  border: ${(p) => (p.$ghost ? `1px solid ${colors.line}` : "none")};
  &:hover { filter: brightness(0.96); }
`;
